<template>
    <v-dialog v-model="dialog" :width="400" scrollable>
        <template v-slot:activator="{props}">
            <v-btn
                variant="outlined"
                class="mb-2 text-black"
                color="grey-darken-1"
                block
                data-cy="add-service-button"
                :size="$breakpoint.smAndDown ? 'small' : 'default'"
                v-bind="props"
                v-text="$t('pnr_import')"
            />
        </template>
        <v-card>
            <v-card-title>
                {{ $t('pnr_import') }}
            </v-card-title>
            <v-card-text class="pb-0">
                <v-skeleton-loader v-if="suppliersLoading" class="my-2" type="text@3" />
                <v-radio-group v-else v-model="supplierId">
                    <v-radio
                        v-for="supplierItem in supplierItems"
                        :key="supplierItem.value"
                        :label="supplierItem.name"
                        :value="supplierItem.id"
                    />
                </v-radio-group>
                <v-text-field
                    v-model="referenceNumber"
                    variant="outlined"
                    density="compact"
                    :label="$t('reference_number')"
                />
            </v-card-text>
            <v-card-actions class="justify-center">
                <div class="d-flex pb-2">
                    <v-btn :disabled="!supplierId" class="mx-1" variant="flat" color="primary" @click="importPNR">
                        {{ $t('import') }}
                    </v-btn>
                    <v-btn variant="flat" class="mx-1" @click="dialog = false">
                        {{ $t('close') }}
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Emit, Vue, Watch} from 'vue-facing-decorator'

    @Component
    export class PNRImportDialog extends Vue {
        dialog = false

        referenceNumber = null
        supplierId = null

        suppliersLoading = false
        supplierItems = []

        @Watch('dialog')
        async onDialogChange() {
            if (this.dialog) {
                await this.loadSuppliers()
            }
        }

        @Emit()
        importPNR() {
            this.dialog = false

            return this.PNRRequestData
        }

        async loadSuppliers() {
            try {
                this.suppliersLoading = true

                const rs = await Promise.all(
                    this.$conf.public.account.addOfflineServicePNRSuppliers.map(sName => {
                        return this.$api.suppliers.get({name: sName, productType: 'extraService'})
                    })
                )

                this.supplierItems = rs.reduce((suppliers, el) => {
                    if (el.suppliers?.[0]) {
                        suppliers.push(el.suppliers?.[0])
                    }

                    return suppliers
                }, [])

                // eslint-disable-next-line no-empty
            } catch (e) {
            } finally {
                this.suppliersLoading = false
            }
        }

        get PNRRequestData() {
            return {
                refNumber: this.referenceNumber,
                supplierId: this.supplierId,
            }
        }
    }

    export default PNRImportDialog
</script>
